import { render, staticRenderFns } from "./img-preview.vue?vue&type=template&id=15a9f4d3&scoped=true"
import script from "./img-preview.vue?vue&type=script&lang=js"
export * from "./img-preview.vue?vue&type=script&lang=js"
import style0 from "./img-preview.vue?vue&type=style&index=0&id=15a9f4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9f4d3",
  null
  
)

export default component.exports